var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABd0lEQVR4nO3YvUoDQRiF4VfFQkHQxmDrBQjWgo2tnVbaGRuvx0abXISVjZ2FYCkbDIKVomBhp010LZzBGLLs7O7MuIPngSEQEs53vs0PCYiIiIiIiIiIiPwrUw2eOwOsA/PANfDuZaJqVs3tfezgbeAZyM15AXYj5u8AjyP5D+a+KDaB4Ui4PR9AN0J+12SN5w+BrQj5XE0Ij7WEovL2XATMBmCOyVc/xhLKyufAa4DcX2aBt5IhQizhkPLyOXDnMbNQz2EQn0twLZ8Dxx7ySi0CmeNATZdQpXxmZotiGbhxHOwTOKqRcYB7+VtgpXabmkIuofXlrRBLSKa85XMJyZW3fCwh2fJWkyUkX97qAH3cvyJPgFPcy/dNRqtVeSVUOa2+8uN8LyGp8pavJSRZ3mq6hKTLWx3cfzuMnowEPvBcLQBnuJc/B5b+ZNKApoF9YEBx8QGwZx4bRZN/hZtYAzb4eX8/AZd8f16IiIiIiIiIiIiIiATyBaq4ivr6kmdXAAAAAElFTkSuQmCC",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    preserveAspectRatio: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9a7b090f81652a19c5174ddc539c0239.svg";
export { ForwardRef as ReactComponent };